import apiData from './api';
import webhookData from './webhook';

const restServicesData = [apiData, webhookData];

export default restServicesData;
